import { Box } from "@mui/material"
import { isNil } from "lodash"
import { useDispatch, useSelector } from "react-redux"
import { AppState } from "../../core/app/AppReducer"
import { setBarren } from "../OotrReducer"
import { LocationQueryAutocomplete } from "./LocationAutocomplete"


interface BarrenHintsTrackerProps {
}

const BarrenHintsTracker = (props: BarrenHintsTrackerProps) => {

    let dispatch = useDispatch();
    let nbBarrens = useSelector((state: AppState) => state.ui.ootr.main.nbBarren);
    let barrens = useSelector((state: AppState) => state.ui.ootr.main.barren);

    return <Box display="flex" flexBasis="fit-content" flexDirection={"column"} textAlign={"center"}>
        {Array.from(Array(nbBarrens), (e, i) => {
            if (isNil(barrens[i]))
                return <LocationQueryAutocomplete
                    sx={{ backgroundColor: "#FF7F7F", width: "200px" }}
                    additionalOnChange={(c) => dispatch(setBarren({ barren: c, id: i }))}
                    selection={barrens?.[i]}
                    label="Barren"
                />
            return <Box fontSize={"16px"} color={"red"} onContextMenu={() => dispatch(setBarren({ barren: null, id: i }))} onClick={() => dispatch(setBarren({ barren: null, id: i }))} >{barrens?.[i].name}</Box>

        })}

    </Box>
}

export default BarrenHintsTracker